import { HrpBaseClient } from './HrpBaseClient'

export class HrpMemberClient extends HrpBaseClient {
  constructor(
    hrpProxyApiUrl = process.env.HRP_PROXY_API_URL,
    hrpProxySecretName = process.env.HRP_PROXY_SECRET_NAME,
    axiosOptions
  ) {
    super(hrpProxyApiUrl, hrpProxySecretName, axiosOptions)
  }

  async getMembers({ 
        hccId, 
        subscriptionHccId, 
        includeDepartmentHistory, 
        includeCob, 
        includeBenefitPlanHistory, 
        includeOtherIds, 
        includeMailingAddress, 
        includeHomeAddress, 
        includeEnrollments, 
        includeGenderCode, 
        includeMaritalStatusFact, 
        includeMemberCurrentContactInfo, 
        includeEmploymentStatusCode, 
        includeMemberHistFactToPractitnr,
        taxId, 
        lastName, 
        firstName, 
        dob, 
        offset, 
        limit 
  }) {
    await this.createSecureAxiosInstance()
    
    const searchParams = {
        MEMBER_HCC_ID: hccId,
        MEMBER_LAST_NAME: lastName,
        MEMBER_FIRST_NAME: firstName,
        MEMBER_BIRTH_DATE_KEY: dob,
        SUBSCRIPTION_HCC_ID: subscriptionHccId,
        TAX_ID: taxId,
        offset,
        limit,
        includeBenefitPlanHistory, 
        includeDepartmentHistory, 
        includeOtherIds, 
        includeCob, 
        includeMailingAddress, 
        includeHomeAddress, 
        includeEnrollments, 
        includeGenderCode, 
        includeMaritalStatusFact, 
        includeMemberCurrentContactInfo, 
        includeEmploymentStatusCode, 
        includeMemberHistFactToPractitnr
    }

    try {
        const response = await this.secureAxiosInstance.get(`/admin/api/member/db/getMembers`, {
            params: searchParams
        })

        return response.data
    } 
    catch (e) {
        throw e.response
    }
  }

   async getMemberHistory({ hccId }) {
    await this.createSecureAxiosInstance()

    const searchParams = {
        MEMBER_HCC_ID: hccId
    }

    try {
        const response = await this.secureAxiosInstance.get(`/admin/api/member/db/getMemberHistory`, {
            params: searchParams
        })

        return response.data
    } 
    catch (e) {
        throw e.response
    }
  }
}
